export default {
  install: (Vue) => {
    Vue.directive('reveal', {
      beforeMount: (el, binding) => {
        const customClass = binding.value?.class || 'v-reveal'

        el.classList.add(customClass)
      },
      mounted: (el, binding) => {
        const delay = binding.value?.delay || 150
        const customClassActive = binding.value?.activeClass || 'v-reveal-active'

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !entry.target.classList.contains(customClassActive)) {
              setTimeout(() => {
                entry.target.classList.add(customClassActive)
              }, delay)
            }
          })
        })
        observer.observe(el)
      },
    })
  },
}
